import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../api.service';
import { CookieService } from 'ngx-cookie-service';
import { CommonService } from "../../shared/common.service";
import { HttpParams } from '@angular/common/http';

interface User {
  id: string;
  first_name: string;
  last_name: string;
  mobile: string;
  email: string;
  role: string;
  designation: string;
  site_location: string;
  site_city: string;
  site_state: string;
  site_country: string;
  site_address: string;
  status: string;  // status is treated as a string
  name: string;
}

@Component({
  selector: 'app-users-list',
  templateUrl: './users-list.component.html',
  styleUrls: ['./users-list.component.scss']
})
export class UsersListComponent implements OnInit {
  users: User[] = [];
  filteredData: User[] = [];
  paginatedData: User[] = [];
  searchText = '';
  searchSite = '';
  roleFilter = '';
  designationFilter = '';
  statusFilter = '';
  totalPages: number[] = [];
  // currentPage = 0;
  // pageSize = 10;

  currentPage = 1;
  pageSize = 10;  
  pages = 0; 
  totalUsers = 0; 
  data: User[] = [];

  selectedUserId: string = '';

  authToken: string | null=null;
  previousPage: number;

  
  pageNumbersToShow: number = 4; // Number of page buttons to display
  pageRange: number[] = []; // Array to hold the page range for display
  maxPagesToShow: number = 4; // Show 4 pages at a time


  constructor(private apiService: ApiService, private router: Router,private cookieService: CookieService, private commonService: CommonService,
    private route: ActivatedRoute 
  ) {}

  ngOnInit(): void {
    let userData = this.commonService.getUserData(); 

    if (userData == null || userData.designation != 'CRO') {
      this.commonService.navigateTo("/");
    }
    // this.loadUsers();
    // this.loadUsers(this.currentPage);
    this.authToken = this.cookieService.get('token');
    console.log('Retrieved Token:', this.authToken);


  let params = new HttpParams();
  this.route.queryParams.subscribe(params => {
    // Set current filters and page from query params
    this.currentPage = +params['page'] || 1;
    this.searchText = params['searchText'] || '';
    this.searchSite = params['searchSite'] || '';
    this.designationFilter = params['designationFilter'] || '';
    this.statusFilter = params['statusFilter'] || '';
    this.loadUsers(this.currentPage);
});


this.searchUsers();

  }


/*
searchUsers(): void {
  this.updateQueryParams();
  this.apiService.getUserList(this.currentPage, this.pageSize, this.searchText, this.searchSite, this.designationFilter, this.statusFilter).subscribe(
    (response: any) => {
      this.users = response.data;
      this.pages = response.totalPages;
      this.totalUsers = response.totalUsers;
    },
    (error) => {
      console.error('Error fetching users', error);
    }
  );
}
*/
searchUsers(): void {
  this.updateQueryParams();
  this.currentPage = 1;
  this.loadUsers(1);
}

loading: boolean = false;
loadUsers(page: number): void {
  this.loading = true;

 // Provide default empty values for filters that are not set
 const searchText = this.searchText || '';
 const searchSite = this.searchSite || '';
 const designationFilter = this.designationFilter || '';
 const statusFilter = this.statusFilter || '';

 const userData = this.commonService.getUserData();

  if (!userData || !userData.id) {
    this.loading = false;
    return;
  }

  // this.apiService.getUserList(page, this.pageSize, this.searchText, this.searchSite, this.designationFilter, this.statusFilter).subscribe(
    this.apiService.getUserList(page, this.pageSize, searchText, searchSite, designationFilter, statusFilter, userData.id).subscribe(

    (response: any) => {
      this.users = response.data || [];
      this.data = response.data || [];

      // Process user data
      this.users = this.data.map((user: User) => ({
        ...user,
        name: `${user.first_name} ${user.last_name}`,
        site_address: `${user.site_city}, ${user.site_state}, ${user.site_country}`,
        status: this.extractStatus(user.status)  // Convert binary to string
      }));

      // Exclude users with CRO_Enterprise, CRO_Premium, CRO_Standard designations (client-side)
      this.filteredData = this.users.filter(user =>
        user.designation !== 'CRO_Enterprise' &&
        user.designation !== 'CRO_Premium' &&
        user.designation !== 'CRO_Standard'
      );

      // Use server-side pagination totals from API so pagination works correctly
      this.totalUsers = response.totalUsers ?? 0;
      this.pages = Math.max(1, response.totalPages ?? Math.ceil(this.totalUsers / this.pageSize));

      this.updatePageRange();
      this.loading = false;
    },
    error => {
      console.error('Error fetching users', error);
      this.loading = false;
    }
  );
}



updateQueryParams(): void {
  this.router.navigate([], {
    relativeTo: this.route,
    queryParams: {
      page: this.currentPage,
      searchText: this.searchText,
      searchSite: this.searchSite,
      designationFilter: this.designationFilter,
      statusFilter: this.statusFilter
    },
    queryParamsHandling: 'merge'
  });
}

// Update the visible page range based on the current page
updatePageRange(): void {
  this.pageRange = []; // Clear the existing page range

  const startPage = Math.floor((this.currentPage - 1) / this.maxPagesToShow) * this.maxPagesToShow + 1;
  const endPage = Math.min(startPage + this.maxPagesToShow - 1, this.pages);

  for (let i = startPage; i <= endPage; i++) {
    this.pageRange.push(i);
  }
}

nextPage(): void {
  if (this.currentPage < this.pages) {
    this.currentPage++;
    this.updatePageRange();
    this.loadUsers(this.currentPage); // Fetch users for the next page
  }
}

prevPage(): void {
  if (this.currentPage > 1) {
    this.currentPage--;
    this.updatePageRange();
    this.loadUsers(this.currentPage); // Fetch users for the previous page
  }
}

goToPage(pageIndex: number): void {
  if (pageIndex > 0 && pageIndex <= this.pages) {
    this.currentPage = pageIndex;
    this.updatePageRange();
    this.loadUsers(this.currentPage); // Fetch users for the selected page
  }
}



  

  extractStatus(status: string): string {
    if (status === 'Active') return 'Active';
    if (status === 'Inactive') return 'Inactive';
    return 'Unknown'; // Default if status is not recognized
  }
  

  applyFilters(): void {
    if (!this.users || this.users.length === 0) {
      this.filteredData = [];
      return;
    }

    this.filteredData = this.users.filter(user => {
      // Exclude users with CRO_Enterprise, CRO_Premium, CRO_Standard designations
      const isExcludedDesignation = user.designation === 'CRO_Enterprise' || 
                                     user.designation === 'CRO_Premium' || 
                                     user.designation === 'CRO_Standard';
      
      if (isExcludedDesignation) {
        return false;
      }

      // Filter by name or mobile
      const matchesSearchText = !this.searchText || 
        (user.name?.toLowerCase().includes(this.searchText.toLowerCase()) ||
         user.mobile?.includes(this.searchText));

      // Filter by designation
      const matchesDesignation = !this.designationFilter || 
        user.designation === this.designationFilter;

      // Filter by status
      const matchesStatus = !this.statusFilter || 
        user.status === this.statusFilter;

      // Filter by site location
      const matchesSite = !this.searchSite || 
        (user.site_location?.toLowerCase().includes(this.searchSite.toLowerCase()));

      return matchesSearchText && matchesDesignation && matchesStatus && matchesSite;
    });

    // Update pagination
    this.pages = Math.ceil(this.filteredData.length / this.pageSize);
    this.totalUsers = this.filteredData.length;
    this.currentPage = 1; // Reset to first page when filtering
    this.updatePageRange();
    this.updatePaginatedData();
  }
  
  calculateTotalPages(): void {
    const pageCount = Math.ceil(this.filteredData.length / this.pageSize);
    this.totalPages = Array.from({ length: pageCount }, (_, i) => i);
  }

  updatePaginatedData(): void {
    const start = (this.currentPage - 1) * this.pageSize;
    const end = start + this.pageSize;
    this.paginatedData = this.filteredData.slice(start, end);
  }

  // goToPage(pageIndex: number): void {
  //   this.currentPage = pageIndex;
  //   this.updatePaginatedData();
  // }

  // prevPage(): void {
  //   if (this.currentPage > 0) {
  //     this.currentPage--;
  //     this.updatePaginatedData();
  //   }
  // }

  // nextPage(): void {
  //   if (this.currentPage < this.totalPages.length - 1) {
  //     this.currentPage++;
  //     this.updatePaginatedData();
  //   }
  // }

  // editUser(userId: string) {
  //   this.router.navigate([`/edit-user/${userId}`]);
  // }
  
  // viewUser(userId: string): void {
  //   this.router.navigate(['/view-user/${userId}']);
  // }


  editUser(userId: string, currentPage: number): void {
    this.router.navigate([`/edit-user/${userId}`], { 
      queryParams: {
        page: currentPage,
        searchText: this.searchText,
        searchSite: this.searchSite,
        designationFilter: this.designationFilter,
        statusFilter: this.statusFilter
      }
    });
  }
  
  viewUser(userId: string, currentPage: number): void {
    this.router.navigate([`/edit-user/${userId}`], { 
      queryParams: {
        page: currentPage,
        searchText: this.searchText,
        searchSite: this.searchSite,
        designationFilter: this.designationFilter,
        statusFilter: this.statusFilter
      }
    });
  }
  

  clear(): void {
    this.searchText = '';
    this.searchSite = '';
    this.designationFilter = '';
    this.statusFilter = '';
    this.currentPage = 1;
    this.updateQueryParams();
    this.loadUsers(1);
  }

  disableUser(id: number, isActive: boolean): void {
    console.log('Received ID:', id); // Debugging
    console.log('Received is_active:', isActive); // Debugging

    if (!id) {
        console.error('User ID is undefined');
        return;
    }

    const payload = { is_active: isActive ? 1 : 0 };
    this.apiService.post(`api/deactivateUser/${id}`, payload).subscribe(
        (response) => {
            console.log('User status updated:', response);
            this.loadUsers(this.currentPage); // Refresh the user list
        },
        (error) => {
            console.error('Error updating user status:', error);
            window.alert('Failed to update user status.');
        }
    );
}
 
toggleUserStatus(user: User): void {
  // Get current logged-in user
  const currentUser = this.commonService.getUserData();
  
  // Prevent users from inactivating themselves
  if (currentUser && currentUser.id && currentUser.id.toString() === user.id.toString()) {
    if (user.status === 'Active') {
      window.alert('You cannot inactivate your own account. Please contact an administrator.');
      return;
    }
  }

  const newStatus = user.status === 'Active' ? 'inactive' : 'active'; // Ensure lowercase 'active'/'inactive'

  this.apiService.updateStatus(user.id, newStatus).subscribe(
    response => {
      console.log('User status updated successfully', response);
      // Update the user's status in the local array
      user.status = newStatus === 'active' ? 'Active' : 'Inactive'; // Update local status
      // Optionally, refresh the user list or update the UI
      this.loadUsers(this.currentPage);
    },
    error => {
      console.error('Error updating user status', error);
      window.alert('Failed to update user status.');
    }
  );
}

// === Modal Methods ===
openAddUserModal(): void {
  const modal = new (window as any).bootstrap.Modal(document.getElementById('addUserModal'));
  modal.show();
}

openEditUserModal(user: User): void {
  this.selectedUserId = user.id;
  const modal = new (window as any).bootstrap.Modal(document.getElementById('editUserModal'));
  modal.show();
}

onUserAdded(): void {
  const modalEl = document.getElementById('addUserModal');
  const modal = (window as any).bootstrap.Modal.getInstance(modalEl);
  modal?.hide();
  this.loadUsers(this.currentPage);
}

onUserUpdated(): void {
  const modalEl = document.getElementById('editUserModal');
  const modal = (window as any).bootstrap.Modal.getInstance(modalEl);
  modal?.hide();
  this.loadUsers(this.currentPage);
}

isCurrentUser(user: User): boolean {
  const currentUser = this.commonService.getUserData();
  return currentUser && currentUser.id && currentUser.id.toString() === user.id.toString();
}
}